// !function(e){e(document).ready(function(){e(".drop-btn").click(function(){var o=e(this),r=o.find(".drop-icon"),s=o.next();r.hasClass("off-drop")?(r.removeClass("off-drop").text(r.text().replace("+","-")),s.css("max-height",800)):(r.addClass("off-drop").text(r.text().replace("-","+")),s.css("max-height",0))}),e(".promoslide-main").slick({slidesToShow:5,slidesToScroll:3,prevArrow:e(".promo-slider .promo-prev"),nextArrow:e(".promo-slider .promo-next"),infinite:!1,responsive:[{breakpoint:767,settings:{slidesToShow:3.5,prevArrow:!1,nextArrow:!1,swipeToSlide:!0}},{breakpoint:479,settings:{slidesToShow:2.5,prevArrow:!1,nextArrow:!1}}]}),e(".mkt-slider-wrapper .slideshow").slick({lazyLoad:"ondemand",slidesToShow:5,slidesToScroll:1,prevArrow:e(".mkt-slider-wrapper .promo-prev.prev1"),nextArrow:e(".mkt-slider-wrapper .promo-next.next1"),infinite:!1,responsive:[{breakpoint:767,settings:{slidesToShow:3.5,prevArrow:!1,nextArrow:!1,swipeToSlide:!0}},{breakpoint:479,settings:{slidesToShow:2.5,slidesToScroll:2}}]}),e(".special-dropdown-mob .header.button-drop").click(function(){e(this).siblings(".shop-more-lists").toggleClass("drop-off")}),e("#sale-banner .banner-details a").click(function(o){o.preventDefault();var r="#modal-sale-banner"+e(this).data("lcount").toString();e(r).fadeIn(500),e("#black-overlay5").fadeIn(500)}),e(".video-trigger-btn").click(function(){e(".video-container").append("<iframe width='560' height='315' src='https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Safety_Video1920x1080.mp4?v=1594105519' frameborder='0' allow='accelerometer; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"),e(".video-overlay").show(),e("#black-overlay5").show(),e("#video_close_inner").show()}),e(".slider-trigger").slick({lazyLoad:"ondemand",slidesToShow:1,slidesToScroll:1,speed:1e3,autoplay:!0,autoplaySpeed:5e3,prevArrow:e("#sale-banner .promo-prev.saleprev"),nextArrow:e("#sale-banner .promo-next.salenext"),pauseOnHover:!0,adaptiveHeight:!0}),e("#custom-banner .slider-cont").slick({lazyLoad:"ondemand",slidesToShow:1,slidesToScroll:1,speed:1e3,autoplay:!0,autoplaySpeed:4e3,fade:!0,pauseOnHover:!0})})}(jQuery);
! function(e) {
  e(document).ready(function() {
    e(".drop-btn").click(function() {
      var o = e(this),
          r = o.find(".drop-icon"),
          s = o.next();
      r.hasClass("off-drop") ? (r.removeClass("off-drop").text(r.text().replace("+", "-")), s.css("max-height", 800)) : (r.addClass("off-drop").text(r.text().replace("-", "+")), s.css("max-height", 0))
    }), e(".promoslide-main").slick({
      slidesToShow: 5,
      slidesToScroll: 3,
      prevArrow: e(".promo-slider .promo-prev"),
      nextArrow: e(".promo-slider .promo-next"),
      infinite: !1,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 3.5,
          prevArrow: !1,
          nextArrow: !1,
          swipeToSlide: !0
        }
      }, {
        breakpoint: 479,
        settings: {
          slidesToShow: 2.5,
          prevArrow: !1,
          nextArrow: !1
        }
      }]
    }), e(".mkt-slider-wrapper .slideshow").each((i, a) => {
      var $this = e(a)
      $this.slick({
        lazyLoad: "ondemand",
        slidesToShow: 5,
        autoplay: !0,
        autoplaySpeed: 3e3,
        slidesToScroll: 1,
        prevArrow: $this.parent().find(".promo-prev.prev1"),
        nextArrow: $this.parent().find(".promo-next.next1"),
        infinite: !1,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 3.5,
            prevArrow: !1,
            nextArrow: !1,
            swipeToSlide: !0
          }
        }, {
          breakpoint: 479,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2
          }
        }]
      })
    }), 

      e(".special-dropdown-mob .header.button-drop").click(function() {
      e(this).siblings(".shop-more-lists").toggleClass("drop-off")
    }),

      e("#sale-banner .banner-details a").click(function(o) {
      o.preventDefault();
      var r = "#modal-sale-banner" + e(this).data("lcount").toString();
      e(r).fadeIn(500), e("#black-overlay5").fadeIn(500)
    }),
      
      e(".video-trigger-btn").click(function() {
      const o = e("<video id='frameActive' class='pabs w-100p h-100p pt-0 pl-0' src='https://cdn.shopify.com/s/files/1/0063/4932/4335/files/yt1s.com_-_All_Together_Now_60s_1.mp4?v=1638436466' autobuffer='auto' preload controls loop></video>");
      e(".video-container").append(o), document.getElementById("frameActive").play(), e(".video-overlay").show(), e("#black-overlay5").show(), e("#video_close_inner").show()
    }),

      e(".slider-trigger").slick({
      lazyLoad: "ondemand",
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1e3,
      autoplay: !0,
      autoplaySpeed: 5e3,
      prevArrow: e("#sale-banner .promo-prev.saleprev"),
      nextArrow: e("#sale-banner .promo-next.salenext"),
      pauseOnHover: !0,
      adaptiveHeight: !0
    }), 
 
      
      e("#custom-banner .slider-cont").slick({
      lazyLoad: "ondemand",
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1e3,
      autoplay: !0,
      autoplaySpeed: 4e3,
      fade: !0,
      pauseOnHover: !0
    })
  })
}(jQuery);